import { IconProps } from '@sharefiledev/flow-web';

export const NullIcon: React.FC<IconProps> = (props: IconProps) => null;
